export const MS_PER_SECOND = 1000
